import { SignalElement, inject } from "../../di";
import type { IPreviewState } from "./types";

export class PreviewSignalElement extends SignalElement {
  @inject<IPreviewState>("previewState")
  protected previewState!: IPreviewState;

  override connectedCallback() {
    super.connectedCallback();
    // Attribute set once; isPreviewMode is determined from URL at app init and never changes
    if (this.previewState.isPreviewMode.get()) {
      this.setAttribute("preview-mode", "");
    }
  }
}
